"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = require("./context");
var fontThemesMap = {};
context_1.inlineModulesContext.onSetFonts = function () {
    Object.keys(fontThemesMap).forEach(function (fontStyleName) {
        delete fontThemesMap[fontStyleName];
    });
    Object.keys(context_1.inlineModulesContext.fontThemes).forEach(function (fontStyleName) {
        fontThemesMap[fontStyleName] = function () { return context_1.inlineModulesContext.fontThemes[fontStyleName]; };
    });
};
exports.default = fontThemesMap;
//# sourceMappingURL=wix-font-themes.js.map